"use strict";

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dayjs_1 = __importDefault(require("dayjs"));

var firestore_1 = require("firebase/firestore");

var firebase_1 = require("../../../config/firebase");

var functions_1 = require("../../../utils/functions");

var Espace_1 = __importDefault(require("../../Model/Espace"));

var User_1 = __importDefault(require("../../User"));

var Event_1 = __importDefault(require("../Event"));

var Commande = /*#__PURE__*/function (_Espace_1$default) {
  _inherits(Commande, _Espace_1$default);

  var _super = _createSuper(Commande);

  function Commande(props) {
    _classCallCheck(this, Commande);

    return _super.call(this, _objectSpread({
      collectionName: 'commandes',
      tabs: [{
        label: 'Tous les bons',
        orderDirection: 'desc',
        orderField: 'createdAt',
        pathname: "/espaces/".concat(props.espaceId, "/bons-commande/"),
        wheres: {
          isDraft: false
        }
      }, {
        label: 'En attente',
        orderDirection: 'desc',
        orderField: 'createdAt',
        pathname: "/espaces/".concat(props.espaceId, "/bons-commande/en-attente/"),
        wheres: {
          isDraft: false,
          status: 'waiting'
        }
      }, {
        label: 'Caché',
        orderDirection: 'desc',
        orderField: 'createdAt',
        pathname: "/espaces/".concat(props.espaceId, "/bons-commande/cache/"),
        wheres: {
          hidden: true,
          isDraft: false
        }
      }, {
        label: 'Brouillon',
        orderDirection: 'desc',
        orderField: 'createdAt',
        pathname: "/espaces/".concat(props.espaceId, "/bons-commande/brouillon/"),
        wheres: {
          isDraft: true
        }
      }]
    }, props));
  }

  _createClass(Commande, [{
    key: "confirmByUser",
    value: function () {
      var _confirmByUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(commandeId, values) {
        var _a, ref, documentSnapshot, data, verification, date, newData, eventData;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(((_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) && values.contactEmail)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return User_1.default.sendSignInLinkToEmail(values.contactEmail);

              case 3:
                ref = (0, firestore_1.doc)(this.getCollectionRef(), commandeId);
                _context.next = 6;
                return (0, firestore_1.getDoc)(ref);

              case 6:
                documentSnapshot = _context.sent;

                if (!(!documentSnapshot || !documentSnapshot.exists())) {
                  _context.next = 9;
                  break;
                }

                throw new Error("La commande n'existe pas");

              case 9:
                data = documentSnapshot.data();

                if (data) {
                  _context.next = 12;
                  break;
                }

                throw new Error('La commande ne contient aucune donnée');

              case 12:
                if (!data.deleted) {
                  _context.next = 14;
                  break;
                }

                throw new Error('La commande est supprimée');

              case 14:
                if (!('paid' === data.status)) {
                  _context.next = 16;
                  break;
                }

                throw new Error('Cette commande est déjà payée');

              case 16:
                _context.next = 18;
                return Commande.verificationProduits(values.produits || data.produits);

              case 18:
                verification = _context.sent;

                if (!verification) {
                  _context.next = 28;
                  break;
                }

                date = (0, dayjs_1.default)();
                newData = _objectSpread(_objectSpread({}, values), {}, {
                  confirmedAt: date.toISOString(),
                  isDraft: false,
                  status: 'confirmed',
                  updatedAt: date.toISOString()
                });
                _context.next = 24;
                return (0, firestore_1.updateDoc)((0, firestore_1.doc)(this.getCollectionRef(), commandeId), newData);

              case 24:
                if (!data.userId) {
                  _context.next = 28;
                  break;
                }

                eventData = new Event_1.default({
                  espaceId: data.boutique
                });
                _context.next = 28;
                return eventData.create({
                  data: {
                    object: newData
                  },
                  type: 'order.confirmed',
                  userId: data.userId
                });

              case 28:
                return _context.abrupt("return", verification);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirmByUser(_x, _x2) {
        return _confirmByUser.apply(this, arguments);
      }

      return confirmByUser;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        var user, userId, verification, constraints, q, querySnapshot, tmp, ref, _querySnapshot$docs, newData, documentSnapshot;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                user = firebase_1.auth.currentUser;

                if (user) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("L'utilisateur doit être connecté pour enregistrer un document");

              case 3:
                userId = data.userId;

                if (userId) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('Impossible de créer une commande sans utilisateur');

              case 6:
                if (!(!data.produits || 0 === data.produits.length)) {
                  _context2.next = 8;
                  break;
                }

                throw new Error('Impossible de créer une commande sans produit');

              case 8:
                _context2.next = 10;
                return Commande.verificationProduits(data.produits);

              case 10:
                verification = _context2.sent;
                console.info('verification', verification);

                if (verification) {
                  _context2.next = 14;
                  break;
                }

                throw new Error("Au moins un produit n'est pas disponible");

              case 14:
                constraints = [(0, firestore_1.where)('userId', '==', userId), (0, firestore_1.where)('status', '==', 'waiting'), (0, firestore_1.where)('deleted', '==', false), (0, firestore_1.where)('boutique', '==', this.espaceId)];
                q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
                _context2.next = 18;
                return (0, firestore_1.getDocs)(q);

              case 18:
                querySnapshot = _context2.sent;

                if (!(querySnapshot.size > 0)) {
                  _context2.next = 27;
                  break;
                }

                if (!(querySnapshot.size > 1)) {
                  _context2.next = 22;
                  break;
                }

                throw new Error("Ce n'est pas normal, il ne devrait pas avoir plusieurs commandes");

              case 22:
                _querySnapshot$docs = _slicedToArray(querySnapshot.docs, 1);
                tmp = _querySnapshot$docs[0];
                ref = tmp.ref;
                _context2.next = 28;
                break;

              case 27:
                ref = (0, firestore_1.doc)(this.getCollectionRef());

              case 28:
                newData = this.clean(_objectSpread({
                  createdByUser: user.uid
                }, data), true);

                if (tmp && tmp.get('paiement')) {
                  newData.paiementId = tmp.get('paiement');
                }

                _context2.next = 32;
                return (0, firestore_1.setDoc)(ref, this.initialize(newData));

              case 32:
                _context2.next = 34;
                return (0, firestore_1.getDoc)(ref);

              case 34:
                documentSnapshot = _context2.sent;
                return _context2.abrupt("return", _objectSpread({
                  id: documentSnapshot.id
                }, documentSnapshot.data()));

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x3) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "initialize",
    value: function initialize(data) {
      var _a, _b;

      return this.clean(_objectSpread(_objectSpread({}, data), {}, {
        contactFirstName: (data === null || data === void 0 ? void 0 : data.contactFirstName) ? (0, functions_1.capitalize)(data === null || data === void 0 ? void 0 : data.contactFirstName) : undefined,
        contactLastName: (data === null || data === void 0 ? void 0 : data.contactLastName) ? (0, functions_1.capitalize)(data === null || data === void 0 ? void 0 : data.contactLastName) : undefined,
        isDraft: (_a = data === null || data === void 0 ? void 0 : data.isDraft) !== null && _a !== void 0 ? _a : false,
        status: (_b = data === null || data === void 0 ? void 0 : data.status) !== null && _b !== void 0 ? _b : 'waiting'
      }));
    }
  }, {
    key: "getNextReference",
    value: function () {
      var _getNextReference = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var debut, fin, constraints, q, querySnapshot, reference;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                debut = (0, dayjs_1.default)().format('YYWWE');
                fin = String(parseInt(debut, 10) + 1);
                constraints = [(0, firestore_1.where)('reference', '>', debut), (0, firestore_1.where)('reference', '<', fin), (0, firestore_1.orderBy)('reference')];
                q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
                _context3.next = 6;
                return (0, firestore_1.getDocs)(q);

              case 6:
                querySnapshot = _context3.sent;
                reference = "".concat(debut, "0001");

                if (querySnapshot.size > 0) {
                  reference = querySnapshot.docs[querySnapshot.size - 1].get('reference');
                  reference = debut + "0000".concat(parseInt(reference.substr(-3), 10) + 1).slice(-4);
                }

                return _context3.abrupt("return", reference);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getNextReference() {
        return _getNextReference.apply(this, arguments);
      }

      return getNextReference;
    }()
  }], [{
    key: "findByCheckoutSessionId",
    value: function () {
      var _findByCheckoutSessionId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(sessionId) {
        var constraints, q, querySnapshot;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                constraints = [(0, firestore_1.where)('checkoutSessionId', '==', sessionId)];
                q = (0, firestore_1.query).apply(void 0, [(0, firestore_1.collection)(firebase_1.firestore, 'commandes')].concat(constraints));
                _context4.next = 4;
                return (0, firestore_1.getDocs)(q);

              case 4:
                querySnapshot = _context4.sent;

                if (!(querySnapshot.empty || querySnapshot.size !== 1)) {
                  _context4.next = 7;
                  break;
                }

                throw new Error('Il y a une erreur');

              case 7:
                return _context4.abrupt("return", _objectSpread({
                  id: querySnapshot.docs[0].id
                }, querySnapshot.docs[0].data()));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function findByCheckoutSessionId(_x4) {
        return _findByCheckoutSessionId.apply(this, arguments);
      }

      return findByCheckoutSessionId;
    }()
  }, {
    key: "watchByTokenAndId",
    value: function watchByTokenAndId(token, id, callback, error) {
      return (0, firestore_1.onSnapshot)((0, firestore_1.doc)(firebase_1.firestore, 'commandes', id), function (snapshot) {
        if (!snapshot.exists || snapshot.get('token') !== token) {
          throw new Error("la commande n'existe pas");
        }

        return callback(_objectSpread({
          id: snapshot.id
        }, snapshot.data()));
      }, error);
    }
  }, {
    key: "calculateProduitsAmount",
    value: function calculateProduitsAmount(produits) {
      if (!produits || 0 === produits.length) {
        return 0;
      }

      return produits.reduce(function (cumul, produit) {
        var price = produit.price,
            quantity = produit.quantity;
        return cumul + quantity * (price || 0);
      }, 0);
    }
  }, {
    key: "verificationProduits",
    value: function () {
      var _verificationProduits = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(items) {
        var promiseProduits, produits, unavailableProduits;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                promiseProduits = items.map(function (_ref) {
                  var id = _ref.id,
                      price = _ref.price,
                      quantity = _ref.quantity;
                  return new Promise(function (resolve, reject) {
                    return (0, firestore_1.getDoc)((0, firestore_1.doc)(firebase_1.firestore, 'produits', id)).then(function (d) {
                      return resolve({
                        id: id,
                        price: price,
                        quantity: quantity,
                        amount: price,
                        deleted: d.get('deleted') || false,
                        hasInventory: d.get('hasInventory') || false,
                        qtyAvailable: d.get('qtyAvailable') || 0,
                        qtyReserved: d.get('qtyReserved') || 0
                      });
                    }).catch(reject);
                  });
                });
                _context5.next = 3;
                return Promise.all(promiseProduits);

              case 3:
                produits = _context5.sent;
                unavailableProduits = [];
                produits.forEach(function (_ref2) {
                  var deleted = _ref2.deleted,
                      hasInventory = _ref2.hasInventory,
                      id = _ref2.id,
                      quantity = _ref2.quantity,
                      qtyAvailable = _ref2.qtyAvailable,
                      qtyReserved = _ref2.qtyReserved;

                  if (deleted || hasInventory && quantity > qtyAvailable - qtyReserved) {
                    unavailableProduits.push(id);
                  }
                });
                return _context5.abrupt("return", 0 === unavailableProduits.length);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function verificationProduits(_x5) {
        return _verificationProduits.apply(this, arguments);
      }

      return verificationProduits;
    }()
  }]);

  return Commande;
}(Espace_1.default);

exports.default = Commande;